export default "__VITE_ASSET__BYupzIHO__"